import React from "react";

import BaseUpdateCard, { type CardStatus } from "./BaseCard";

type Props = {
  status: CardStatus;
};

function CheckingUpdatesCard({ status }: Props): React.JSX.Element {
  return (
    <BaseUpdateCard
      status={status}
      title={"Checking"}
      subtitle={"Looking for new features..."}
      iconName={"arrow-up"}
    />
  );
}

export default CheckingUpdatesCard;
